import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface OnboardingReplayContextValue {
  /** Increments each time a manual replay is requested. */
  replayNonce: number;
  /** Relaunch the full onboarding flow (segmentation → tour/activation → WOW). */
  startReplay: () => void;
}

const OnboardingReplayContext = createContext<OnboardingReplayContextValue | null>(null);

export function OnboardingReplayProvider({ children }: { children: ReactNode }) {
  const [replayNonce, setReplayNonce] = useState(0);
  const startReplay = useCallback(() => setReplayNonce((n) => n + 1), []);
  return (
    <OnboardingReplayContext.Provider value={{ replayNonce, startReplay }}>
      {children}
    </OnboardingReplayContext.Provider>
  );
}

export function useOnboardingReplay(): OnboardingReplayContextValue {
  const ctx = useContext(OnboardingReplayContext);
  // Safe fallback so components don't crash if rendered outside the provider.
  return ctx ?? { replayNonce: 0, startReplay: () => {} };
}
